<script>
    import { datagrid } from './Datagrid.js';
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    export let uid=null;

    let indexOrder=false;
    let titleOrder='';

    function eventOrder(order,dir)
    {
        $datagrid[uid].dir=dir;
        $datagrid[uid].order=order;
    }

    let mouseenterEvent=function(e)
    {
        dispatch('mouseenter', {});
    }
    
    let mouseleaveEvent=function(e)
    {
        dispatch('mouseleave', {});
    }

</script>
<!-- svelte-ignore a11y-missing-attribute -->
{#if $datagrid[uid]!== undefined}
<div class="btn-group float-end mb-1" on:mouseenter={mouseenterEvent} on:mouseleave={mouseleaveEvent}>
    <button class="btn btn-light btn-sm2 dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
        {#if $datagrid[uid].dir=='ASC'}
                <i class="bi bi-sort-down"></i>
        {:else}
                <i class="bi bi-sort-up-alt"></i>
        {/if}
    </button>
    <ul class="dropdown-menu">
        {#each $datagrid[uid].titles as item}
            
            <li><a class="dropdown-item" on:click={()=>{ eventOrder(item.order,'ASC') }}>Ordenar <strong>{item.name} Ascendiente</strong></a></li>
            <li><a class="dropdown-item" on:click={()=>{ eventOrder(item.order,'DESC') }}>Ordenar <strong>{item.name} Descendiente</strong></a></li>
        {/each}
    </ul>    
</div>
{/if}